var $88a3bf0d79ac60db$exports = {};
const $88a3bf0d79ac60db$var$LABELABLE = 'input:not([type="hidden"]), select, textarea';
const $88a3bf0d79ac60db$var$ERRORS = '[data-form-error]';
const $88a3bf0d79ac60db$var$HELP = '.form-group__help';
const $88a3bf0d79ac60db$var$LABEL = '[data-field-label]';
const $88a3bf0d79ac60db$var$LABEL_TEXT = '[data-field-label-text]';
const $88a3bf0d79ac60db$var$REQUIRED = 'data-field-required';
let $88a3bf0d79ac60db$var$fieldIds = 0;
const $88a3bf0d79ac60db$var$MANAGED_DESCRIPTION = /^elm-field-\d+-description-\d+$/;
const $88a3bf0d79ac60db$var$MANAGED_LABEL = /^elm-field-\d+-label$/;
function $88a3bf0d79ac60db$var$describe(control, descriptionIds) {
    // Ids we did not generate are the caller's and survive; the Set keeps a
    // preserved one from being appended again on every rewire.
    const ids = [
        ...new Set((control.getAttribute('aria-describedby') ?? '').split(' ').filter((id)=>id && !$88a3bf0d79ac60db$var$MANAGED_DESCRIPTION.test(id)).concat(descriptionIds))
    ];
    if (ids.length === 0) control.removeAttribute('aria-describedby');
    else control.setAttribute('aria-describedby', ids.join(' '));
}
// Only the name this component gave. A control named by anyone else keeps it.
function $88a3bf0d79ac60db$var$unname(control) {
    if ($88a3bf0d79ac60db$var$MANAGED_LABEL.test(control.getAttribute('aria-labelledby') ?? '')) control.removeAttribute('aria-labelledby');
}
class $88a3bf0d79ac60db$var$ElmField extends HTMLElement {
    connectedCallback() {
        this.fieldId ??= `elm-field-${++$88a3bf0d79ac60db$var$fieldIds}`;
        this.wire();
        this.observer = new MutationObserver(()=>this.wire());
        this.observer.observe(this, {
            childList: true,
            subtree: true
        });
    }
    disconnectedCallback() {
        this.observer.disconnect();
    }
    own(selector) {
        return Array.from(this.querySelectorAll(selector)).filter((el)=>el.closest('elm-field') === this);
    }
    describedBy(node, controls) {
        for(let el = node.parentElement; el; el = el.parentElement){
            const within = controls.filter((control)=>el.contains(control));
            if (within.length === 1) return within;
            if (within.length > 1) return controls;
            if (el === this) break;
        }
        return controls;
    }
    wire() {
        const controls = this.own($88a3bf0d79ac60db$var$LABELABLE);
        const described = new Map(controls.map((control)=>[
                control,
                []
            ]));
        this.own(`${$88a3bf0d79ac60db$var$ERRORS}, ${$88a3bf0d79ac60db$var$HELP}`).forEach((node, index)=>{
            // Ours are positional and get reassigned every wire, so a block
            // appearing earlier cannot take an id another block is still using.
            // An id we did not mint is the caller's and is left alone.
            if (!node.id || $88a3bf0d79ac60db$var$MANAGED_DESCRIPTION.test(node.id)) node.id = `${this.fieldId}-description-${index}`;
            this.describedBy(node, controls).forEach((control)=>described.get(control).push(node.id));
        });
        controls.forEach((control)=>$88a3bf0d79ac60db$var$describe(control, described.get(control)));
        // FormGroup.required renders an asterisk and a class, neither of which
        // reaches assistive technology. The state belongs on the control.
        const required = this.hasAttribute($88a3bf0d79ac60db$var$REQUIRED);
        controls.forEach((control)=>{
            if (required) control.setAttribute('aria-required', 'true');
            else control.removeAttribute('aria-required');
        });
        const [label] = this.own($88a3bf0d79ac60db$var$LABEL);
        if (!label) {
            this.removeAttribute('role');
            this.removeAttribute('aria-labelledby');
            controls.forEach($88a3bf0d79ac60db$var$unname);
            return;
        }
        const [labelText] = this.own($88a3bf0d79ac60db$var$LABEL_TEXT);
        const [control] = controls;
        if (controls.length === 1 && !control.closest('label')) {
            control.id ||= `${this.fieldId}-control`;
            label.htmlFor = control.id;
            this.removeAttribute('role');
            this.removeAttribute('aria-labelledby');
            if (labelText) {
                labelText.id ||= `${this.fieldId}-label`;
                control.setAttribute('aria-labelledby', labelText.id);
            } else $88a3bf0d79ac60db$var$unname(control);
        } else {
            const nameSource = labelText ?? label;
            nameSource.id ||= `${this.fieldId}-label`;
            label.removeAttribute('for');
            this.setAttribute('role', 'group');
            this.setAttribute('aria-labelledby', nameSource.id);
            // The field names the group now; a control still carrying our name from
            // when it was the only one would be announced twice.
            controls.forEach($88a3bf0d79ac60db$var$unname);
        }
    }
}
if (!customElements.get('elm-field')) customElements.define('elm-field', $88a3bf0d79ac60db$var$ElmField);


//# sourceMappingURL=provider-portal.2e011f0d.js.map
